export default __webpack_public_path__ + "7144f9d7f8977f7a12272a9121b00f50.png";